import React from 'react';
import { Col, Row } from 'react-bootstrap';


const Weddingqutes = () => {
    return (
        <Row className='p-4 d-flex align-items-center weddingqutesrow my-4'>
        <Col className="p-4" lg={6} md={10} sm={12}>
            <h1 className="hometitle">Say It With Flowers</h1>
            <p>For those seeking to send that little something extra to someone who has achieved a special milestone or experienced a life event, BloomsyBox is the perfect choice! Our hassle-free subscription service means fresh flowers sent to loved ones' homes or workplaces whenever you want for as long as you want. Starting at just $44.99 you can have a new bouquet of mixed flowers, healthy plants, or even dried luxury arrangements from BloomsyBox delivered to a loved one each month. It's a bouquet. It's a box. It's Bloomsy. It's fast, affordable, and easy; because sending flowers to someone special should always be just that.</p>
        </Col>
    </Row>
    );
};

export default Weddingqutes;